import { withInstall } from "../utils/index.mjs";
import _Field from "./Field.mjs";
const Field = withInstall(_Field);
var stdin_default = Field;
import { fieldProps } from "./Field.mjs";
export {
  Field,
  stdin_default as default,
  fieldProps
};
